import React from 'react';
import AdminManagement from '../PracticeManagement/AdminManagement/AdminManagement';
import './AdminDashboard.css';

const AdminDashboard = () => (
  <div className="admin-dashboard-feature">
    <AdminManagement />
  </div>
);

export default AdminDashboard;
